import { render, staticRenderFns } from "./FPTablePaymentMethods.vue?vue&type=template&id=3fb1add5"
import script from "./FPTablePaymentMethods.vue?vue&type=script&lang=js"
export * from "./FPTablePaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports